module.exports = __webpack_public_path__ + "img/noLgimg.bc1427fe.jpg";